import React, { useEffect, useState } from "react";
import HomeLayout from "layouts/HomeLayout";
import { getLocationList } from "context/actions/location";
import { getConnectList } from "context/actions/connect";
import { getLinkList } from "context/actions/link";
import { getPriceList } from "context/actions/price";
import { getPublicBranchList } from "context/actions/branch";
import Hero from "components/Hero";
import HowItWorks from "components/HowItWorks";
import Services from "components/Services";
import Stats from "components/Stats";
import BranchLocations from "components/BranchLocations";
import Reveal from "components/Reveal";

const HomePage = () => {
  const [location, setLocation] = useState([]);
  const [link, setLink] = useState([]);
  const [price, setPrice] = useState([]);
  const [connect, setConnect] = useState([]);
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getInitData();
  }, []);

  const getInitData = async () => {
    setLoading(true);
    try {
      const [resLoc, resLink, resPrice, resConnect, resBranches] = await Promise.all([
        getLocationList(),
        getLinkList(),
        getPriceList(),
        getConnectList(),
        getPublicBranchList(),
      ]);
      if (resLoc?.status === "success") setLocation(resLoc.data);
      if (resLink?.status === "success") setLink(resLink.data);
      if (resPrice?.status === "success") setPrice(resPrice.data);
      if (resConnect?.status === "success") setConnect(resConnect.data);
      if (resBranches?.status === "success") setBranches(resBranches.data);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full">
      {loading && <div className="fixed top-0 inset-x-0 h-[3px] z-[60] bg-primary animate-pulse" />}

      <Hero linkData={link} />

      <div id="how" className="scroll-mt-20">
        <HowItWorks />
      </div>

      <div id="services" className="scroll-mt-20">
        <Reveal>
          <Services location={location} linkData={link} connect={connect} price={price} />
        </Reveal>
      </div>

      <Stats />

      <div id="branches" className="scroll-mt-20">
        <Reveal>
          <BranchLocations branches={branches} location={location} linkData={link} />
        </Reveal>
      </div>
    </div>
  );
};

HomePage.Layout = HomeLayout;

export default HomePage;
